import { Http } from "../utils/http.js";
class AuctionAPI extends Http {
  getSpecialList(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Special/GetSpecialList",
      method: "post",
      param: param
    });
  }
  getSpecialDetailById(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Special/GetSpecialDetailById",
      method: "post",
      param: param
    });
  }

  getEPDetails(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Details/GetEPDetails",
      method: "post",
      param: param
    });
  }

  biddingHistory(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Details/GetBiddingHistory",
      method: "post",
      param: param,
      load: true
    });
  }

  addPrice2(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Product/AddPrice2",
      method: "post",
      param: param
    });
  }
  addUserLike(param) {
    let _this = this;
    return _this.request({
      url: "/WebApi/Customer/AddUserLike",
      method: "post",
      param: param
    });
  }
}
export { AuctionAPI };
